import React from "react";
import { NoRecords } from "../../common/components/NoRecords";

export function NoEmployees({ message }) {
  return <NoRecords iconName="user times" message={message} />;
}
